/*global define */
/*jshint devel:true*/
/**
 * Generic settings config controller
 */
define(
	'BaseSettingsController',[
		'jquery',
		'underscore',
		'BaseController',
		'BaseModuleModel'
	],
	function ($, _, BaseController, BaseModuleModel) {
		'use strict';

		var ParentClass = BaseController,
			parentClassPrototype = ParentClass.prototype;

		/**
		 * @class
		 * @name CallDiversionSettingsController
		 * @extends BaseController
		 */
		return ParentClass.extend(
			/**
			 * @lends CallDiversionSettingsController.prototype
			 */
			{
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				// MEMBERS
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				/**
				 * Name of the current class. Used to build debug messages.
				 * @type {String}
				 */
				className: 'BaseSettingsController',
				/**
				 * Initial state at object time
				 * @type {String}
				 */
				initState: 'init',
				/**
				 * States and transition definitions
				 * @type {Object}
				 */
				states: {
					init: 'idle pendingOrder',
					idle: 'editing',
					pendingOrder: '',
					editing: 'savingEdit',
					savingEdit: 'settingsSaved editing',
					settingsSaved: 'editing',
					error: '' // all states can go to the error state, so it's optional to specify this
				},

				/**
				 * ModuleModel class, used to convert the given raw module data into an instance of it
				 * @type {BaseModuleModel}
				 */
				moduleClass: BaseModuleModel,

				/**
				 * Module's main BaseView class, used to create a new view instance for the current module.
				 * @warning You need to define it in your own class.
				 * @type {BaseView}
				 */
				viewClass: null,

				autoBindRivets: true,
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				// METHODS
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				render: function () {
					var self = this;
					parentClassPrototype.render.apply(self, arguments);
					self.view.showErrorMessages();
					return self;
				},

				whenInit: function () {
					var self = this,
						model = self.model,
						serviceWrapperModel = self.getServiceWrapperModel(),
						hasPendingOrder = model.get('hasPendingOrder'); // hasPendingOrder is given at preload time

					if (hasPendingOrder) {
						self.setState('pendingOrder');
						return;
					}

					serviceWrapperModel.whenFetched({
						success: function () {
							self.setState('idle');
						},
						error: function () {
							self.setState('error');
						}
					});
				},

				whenPendingOrder: function () {
					var self = this,
						view = self.view;

					view.disableUserInputs();
				},

				whenError: function () {
					var self = this,
						view = self.view;

					view.disableUserInputs();
				},

				whenIdle: function () {
					var self = this;

					self.getServiceModel().once('change', function () {
						self.setState('editing');
					});

				},

				whenEditing: function () {
					var self = this,
						serviceModelList = self.model.get('serviceModelList'),
						view = self.view;

					view.showSaveSettingsNotification().hideSettingsSavedNotification();
				},

				whenSavingEdit: function () {
					var self = this,
						methodName = 'whenSavingEdit',
						serviceWrapperModel = self.getServiceWrapperModel(),
						view = self.view;

					view.hideSaveSettingsNotification().showSettingsSavedNotification();

					serviceWrapperModel.save({}, {
						success: function (model, response, options) {
						},
						error: function (model, xhr, options) {
							self.setState('editing');
						}
					});

					self.setState('settingsSaved');
				},

				whenSettingsSaved: function () {

					var self = this,
						view = self.view;

					view.disableUserInputs();
				}
			}
		);
	}
);
